import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitContact = async (data) => {
  const res = await axios.post(`${API}/contact`, data);
  return res.data;
};
